/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html } from 'lit-all'
/* eslint-disable import/no-unresolved */
class HHPanZoomImage extends BaseElement {
  static properties = {
    scale: { type: Number },
    minScale: { type: Number },
    maxScale: { type: Number },
    startX: { type: Number },
    startY: { type: Number },
    pointerIsDown: { type: Boolean },
    pointerOrigin: { type: Object },
  }

  static styles = css`
    :host {
      display: block;
      position: relative;
      overflow: hidden;
      touch-action: none;
      cursor: grab;
    }
    #container {
      transform-origin: top left;
      will-change: transform;
      transition: transform 0.2s;
    }
  `

  constructor() {
    super()
    this.scale = 1
    this.minScale = 0.5
    this.maxScale = 3
    this.startX = 0
    this.startY = 0
    this.pointerIsDown = false
  }

  render() {
    return html`
      <div
        id="container"
        style="transform: scale(${this.scale}) translate(${this
          .startX}px, ${this.startY}px);"
        @pointermove=${this._onPointerMove}
        @pointerdown=${this._onPointerDown}
        @wheel=${this._onWheel}
        @dragstart=${(event) => event.preventDefault()}
      >
        <slot></slot>
      </div>
    `
  }

  _onWheel(event) {
    event.preventDefault()
    const rect = this.getBoundingClientRect()
    const offsetX = (event.clientX - rect.left) / this.scale
    const offsetY = (event.clientY - rect.top) / this.scale
    const deltaScale = Math.sign(event.deltaY) * -0.05
    const newScale = Math.min(
      this.maxScale,
      Math.max(this.minScale, this.scale + deltaScale)
    )

    // Adjust the translation based on the cursor position for a seamless zoom-in/out experience
    const ratio = newScale / this.scale
    this.startX = offsetX * (1 - ratio) + this.startX * ratio
    this.startY = offsetY * (1 - ratio) + this.startY * ratio

    this.scale = newScale
  }

  _onPointerDown(event) {
    this.pointerIsDown = true
    this.pointerOrigin = { x: event.clientX, y: event.clientY }
    this.shadowRoot.getElementById('container').classList.add('manipulating')
    this.setPointerCapture(event.pointerId)
  }

  _onPointerMove(event) {
    console.log('pointer move')
    // Only allow panning if a pointer is down (i.e., the user is dragging)
    if (!this.pointerIsDown) return

    event.preventDefault()

    // Calculate the new coordinates
    const dx = (event.clientX - this.pointerOrigin.x) / this.scale
    const dy = (event.clientY - this.pointerOrigin.y) / this.scale

    // Set the new start coordinates
    let newStartX = this.startX + dx
    let newStartY = this.startY + dy

    // Calculate bounds based on the current scale
    const rect = this.getBoundingClientRect()
    const containerWidth = rect.width
    const containerHeight = rect.height
    const imageWidth = this.scrollWidth * this.scale
    const imageHeight = this.scrollHeight * this.scale

    // Calculate the boundaries
    const minX = 0
    const maxX = containerWidth - imageWidth
    const minY = 0
    const maxY = containerHeight - imageHeight

    // Clamp the new start coordinates to the boundaries
    newStartX = Math.min(Math.max(newStartX, maxX), minX)
    newStartY = Math.min(Math.max(newStartY, maxY), minY)

    // Update the start coordinates
    this.startX = newStartX
    this.startY = newStartY

    // Reset the pointer origin for the next move event
    this.pointerOrigin = { x: event.clientX, y: event.clientY }

    this.requestUpdate()
  }
}

customElements.define('hh-pan-zoom-image', HHPanZoomImage)
